/**
 * Plovoucí pozice na mapě.
 */
export enum FloatPosition {
    /**
     * Nahoře vlevo.
     */
    TOP_LEFT = 'TOP_LEFT',

    /**
     * Nahoře vpravo.
     */
    TOP_RIGHT = 'TOP_RIGHT',

    /**
     * Vlevo dole.
     */
    BOTTOM_LEFT = 'BOTTOM_LEFT',

    /**
     * Vpravo dole.
     */
    BOTTOM_RIGHT = 'BOTTOM_RIGHT',
}
